import { Stack, Box, Text, HStack } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const MotionBox = motion(Box);
const MotionText = motion(Text);

export default function SectionHeading({ children }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <Stack ref={ref} align="center" direction="row" px={4} overflow="hidden">
      <HStack mx={4}>
        <MotionText
          fontWeight={800}
          fontSize={{ base: "xl", md: "2xl" }}
          whiteSpace="nowrap"
          initial={{ opacity: 0, x: -30 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          {children}
        </MotionText>
      </HStack>
      <MotionBox
        h="1px"
        flex="1"
        bg="chakra-border-color"
        initial={{ scaleX: 0 }}
        animate={inView ? { scaleX: 1 } : {}}
        transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
        style={{ transformOrigin: "left" }}
      />
    </Stack>
  );
}
